import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import IconButton from '@mui/material/IconButton';

import { toggleDarkMode } from '../../store/fuse/dashboard';

const LightDarkToogle = () => {
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const handleToggleDarkMode = (isDark) => dispatch(toggleDarkMode(isDark));

  return (
    <>
      {!darkMode && (
        <IconButton aria-label="activate-dark-mode" size="large" onClick={() => handleToggleDarkMode(true)}>
          <DarkModeIcon sx={{ color: 'black' }} />
        </IconButton>
      )}
      {darkMode && (
        <IconButton aria-label="deactivate-dark-mode" size="large">
          <LightModeIcon fontSize="large" sx={{ color: 'white' }} onClick={() => handleToggleDarkMode(false)} />
        </IconButton>
      )}
    </>
  );
};

export default LightDarkToogle;
